import { render, staticRenderFns } from "./GrupoFinanceiro.vue?vue&type=template&id=90fa7530&"
import script from "./GrupoFinanceiro.vue?vue&type=script&lang=js&"
export * from "./GrupoFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports